import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/lib/query/client';
import { sistemaService } from '@/shared/lib/sistema/sistemaService';

export function useVersaoApiQuery(enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.versaoApi,
    queryFn: sistemaService.obterVersao,
    enabled,
    staleTime: 60_000,
  });
}
